// Заголовок приложения

import { Zap } from 'lucide-react';
import type { ReactNode } from 'react';
import './Layout.css';

interface AppHeaderProps {
  title?: string;
  actions?: ReactNode;
}

export function AppHeader({ 
  title = 'Калькулятор сечения кабеля', 
  actions 
}: AppHeaderProps) {
  return (
    <header className="app-header">
      <h1 className="app-header__title">
        <Zap className="app-header__icon" />
        {title}
      </h1>
      {actions && <div className="app-header__actions">{actions}</div>}
    </header>
  );
}
